import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import saf from "../../Assets/Projects/safaricom.jpg";
import travel from "../../Assets/Projects/travel-app-landing.png"
import AI from "../../Assets/Projects/AI-1.png";
import Angaza from "../../Assets/Projects/angaza.png";
import britam from "../../Assets/Projects/britam.jpg";
import Action from "../../Assets/Projects/Action.png";
import kreamit from "../../Assets/Projects/kreamitMilk.jpg"
import rs4u from "../../Assets/Projects/rs4u.png";
import kcb from "../../Assets/Projects/kcb.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Angaza}
              isBlog={false}
              title="Kalamu Project"
              description="I was pivotal in the Kalamu project, focusing on the integration of secure payment gateways and efficient onboarding processes. Leveraging the latest technologies, I optimized backend performance and implemented robust security measures to protect user data. Additionally, I utilized user data to generate optimized data insights, promoting personalized learning. By analyzing quiz performance, we tailored educational content to meet individual learning needs, enhancing the overall learning experience. This project not only streamlined user interactions but also provided valuable insights into user behavior, driving future improvements and innovations."
              //ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://kalamu.net/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Action}
              isBlog={false}
              title="UCF-101-action-recogition-model"
              description="This project involves developing an action recognition model that identifies different types of actions in video clips. The model is trained using the UCF-101 dataset, which is a large-scale action recognition dataset consisting of 13,320 video clips distributed across 101 action categories."
              ghLink="https://github.com/BruceOnyango/UCF-101-action-recogition-model"
              //demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AI}
              isBlog={false}
              title="Helmet and PPE Vest Object Detector"
              description="In this project, I developed a state-of-the-art object detector designed specifically to identify helmets and Personal Protective Equipment (PPE) vests in real-time. This solution is aimed at enhancing safety compliance in industrial environments by ensuring that workers are properly equipped with necessary safety gear."
              //ghLink="https://github.com/soumyajit4419/Editor.io"
              //demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rs4u}
              isBlog={false}
              title="RS4U Project"
              description={`RS4U is an innovative job search platform designed to connect applicants with recruiters efficiently. Leveraging advanced AI technology, it ensures optimal matches between job seekers and job openings while providing valuable insights for administrators. 

Key Features:

1.Job Search for Applicants:

  Intuitive search interface for job seekers to find relevant opportunities.
  Personalized job recommendations based on user profiles and preferences.

2.Recruiter Dashboard:

  View and manage applicant profiles.
  Automated ranking of applicants using BERT similarity to match qualifications with job requirements.

3.Admin Analytics:

  Comprehensive analytics dashboard.
  Insights into platform activity, user behavior, and engagement metrics.
  Data-driven decision-making tools to optimize platform performance.`}
              ghLink="https://github.com/BruceOnyango/"
             // demoLink="https://drive.google.com/file/d/1Q8jGxBD7EUt6oy3kFVzLxOBoKmmLtYYN/view?usp=sharing" 
            />
          </Col>
         
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kcb}
              isBlog={false}
              title="Bpr Project - (KCB Rwanda)"
              description={`We recently completed a project for BPR Rwanda, utilizing cutting-edge technologies to enhance their digital platform. Our approach focused on ensuring robust security, seamless performance, and an intuitive user experience. By leveraging the latest advancements in web development and software engineering, we successfully delivered a solution that meets the highest standards of modern digital banking.`}
              //ghLink="https://www.britam.com/"
              demoLink="https://bpr.rw/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={britam}
              isBlog={false}
              title="Britam Group Project"
              description="I played a pivotal role in the development and enhancement of Britam's corporate multi-national website, a leading diversified financial services group. This project aimed to revamp Britam’s online presence, ensuring a seamless user experience, robust functionality, and enhanced accessibility to financial services. "
              //ghLink="https://www.britam.com/"
              demoLink="https://www.britam.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={saf}
              isBlog={false}
              title="Safaricom Calendar"
              description="I spearheaded the development for the Safaricom 2023 calendar project, titled 'Places of Hope.' This project involved creating a dynamic and interactive calendar that highlights significant cultural and historical locations across Kenya. Our goal was to not only produce visually stunning content but also to integrate data-driven insights to enhance user engagement and experience."
              //ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
               demoLink="https://www.safaricom.co.ke/placesofhope/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={travel}
              isBlog={false}
              title="Travel App with Data Analytics"
              description="I leveraged the Amadeus API to develop a comprehensive booking system for flights, hotels, and restaurants. This platform allowed users to save their bookings for future reference and discover points of interest. On the data side, I implemented user behavior analytics using the Dash low-code framework, built on Flask. This provided valuable insights into user preferences for booking, travel patterns, and popular destinations, ultimately enhancing user experience and optimizing service offerings."
              ghLink="https://github.com/BruceOnyango/"
              demoLink="https://drive.google.com/file/d/1Q8jGxBD7EUt6oy3kFVzLxOBoKmmLtYYN/view?usp=sharing" 
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kreamit}
              isBlog={false}
              title="Kreamit Project"
              description={`I developed a modern, responsive website designed to deliver a seamless user experience across all devices. Key features include:

1.Responsive Design: The site adapts flawlessly to various screen sizes, ensuring optimal usability on desktops, tablets, and mobile devices.\n
2.Visual Appeal: With a clean and attractive layout, intuitive navigation, and engaging visuals, the site captivates visitors and enhances user engagement.\n
3.High SEO Performance: Implemented best SEO practices, including fast loading times, keyword optimization, and clean, semantic HTML. This ensures excellent search engine rankings and increases organic traffic.\n
4.The combination of these elements results in a professional and accessible online presence that effectively reaches and engages the target audience.`}
              //ghLink="https://www.britam.com/"
              demoLink="https://kreamit.com/"
            />
          </Col>
        
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
